import {
  faArrowRight,
  faChevronDown,
  faChevronLeft,
  faChevronCircleLeft,
  faChevronRight,
  faCaretSquareRight,
  faChevronUp,
  faCircleNotch,
  faClock,
  faMapMarker,
  faUsers,
  faPeopleArrows,
  faLongArrowAltRight,
  faUserShield,
  faInfoCircle,
  faLink,
  faMapMarkedAlt,
  faMoneyCheckAlt,
  faMoneyBill,
  faTheaterMasks,
  faTicket,
  faHome,
  faTimesCircle,
  faCheckCircle,
  faEdit,
  faClipboardList,
  faCashRegister,
  faUserCheck,
  faCalendar,
  faSquare,
  faSearch,
  faSort,
  faSortUp,
  faSync,
  faSortDown,
  faCheck,
  faTimes,
  faExclamation,
  faExclamationTriangle,
  faBold,
  faParagraph,
  faUnderline,
  faPlusCircle,
  faItalic,
  faGlobe,
  faListUl,
  faListOl,
  faSave,
  faQuoteRight,
  faUndo,
  faRedo,
  faImage,
  faTrash,
  faMobileAlt,
  faFileExport,
  faRightToBracket,
  faUserPen,
  faBuilding,
  faEllipsis,
  faCamera,
  faInfo,
  faExclamationCircle,
  faArrowLeft,
  faArrowsRotate
} from '@fortawesome/free-solid-svg-icons';

import { faFacebook } from '@fortawesome/free-brands-svg-icons';

export default {
  solid: [
    faArrowRight,
    faArrowsRotate,
    faArrowLeft,
    faCamera,
    faChevronDown,
    faInfo,
    faExclamationCircle,
    faChevronCircleLeft,
    faChevronLeft,
    faChevronRight,
    faCaretSquareRight,
    faChevronUp,
    faCircleNotch,
    faClock,
    faMapMarker,
    faUsers,
    faPeopleArrows,
    faLongArrowAltRight,
    faUserShield,
    faInfoCircle,
    faLink,
    faMapMarkedAlt,
    faMoneyCheckAlt,
    faMoneyBill,
    faRightToBracket,
    faTheaterMasks,
    faTicket,
    faHome,
    faTimesCircle,
    faCheckCircle,
    faUserPen,
    faEdit,
    faClipboardList,
    faCashRegister,
    faUserCheck,
    faBuilding,
    faCalendar,
    faSquare,
    faSearch,
    faSort,
    faSortUp,
    faSync,
    faSortDown,
    faCheck,
    faTimes,
    faExclamation,
    faExclamationTriangle,
    faBold,
    faParagraph,
    faUnderline,
    faPlusCircle,
    faItalic,
    faGlobe,
    faListUl,
    faListOl,
    faSave,
    faQuoteRight,
    faUndo,
    faRedo,
    faImage,
    faTrash,
    faMobileAlt,
    faFileExport,
    faEllipsis
  ],
  brands: [faFacebook]
};
